import {getDomainList,addDomain, deleteDomain} from '@/libs/api/api';
import {errorHandler, message, logout, loader} from '@/libs/helper';
import constants from '@/libs/constant/constants'
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'

export default{
    components: {
        VerifyDialog: () => import('./VerifyDialog.vue')
    },

    data(){
        return{
            showDialogBox: false,
            addDomain: false,
            newDomain: '',
            domainsList: [],
            selectedDomain: {},
            permissions: permissions
        }
    },

    mounted(){
        if (this.hasPermission(permissions.getDomainList)) this.getDomainsList();
    },
    computed: {
        ...mapGetters(['hasPermission'])
    },

    methods:{
        showDialog(domain){
            this.showDialogBox=true;
            this.selectedDomain=domain;
        },
        closeDialog(){
            this.showDialogBox=false;
        },

        /**
        *  Function to get the list of preadded domains
        *  The api accepts the organisation id and gets a list of domains  
        */
        async getDomainsList(){
            loader(this,true);

            try {
                // body for api
                let body = {
                    organisation:this.$route.params.id,
                }

                // api call
                let response = await getDomainList(body);
                loader(this,false);

                //update the reactive domainList data property with the newly fetched list
                this.domainsList=response.domain;

                
            } catch (error) {
              loader(this,false);  
              message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
              console.error(error);
            }
        },

        /**
         * Function to add a new domain 
         * The api accepts the oraganisation id, the domain name (with https://) and exact domain (without https://)
         */
        async addNewDomain(){
            loader(this,true);
            try{

                //api body
                let body = {
                    organisation: this.$route.params.id,
                    name: 'https://'+this.newDomain,
                    exact_domain: this.newDomain
                }

                //api call
                let response = await addDomain(body);
                loader(this,false);

                //update the reactive domainList data property with the newly fetched domain list
                this.domainsList = response.domain;
                this.addDomain = false;

            } catch (error) {
                loader(this,false);  
                this.addDomain = false;
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                
            }
        },

        /**
         * Function to delete a domain.
         * The api accepts the organisation id and the domain id. The endpoint consists of both these parameters.
         */
        async removeDomain(domainId){

            loader(this,true);
            const orgId = this.$route.params.id;

            try{
                
                //api body
                let body = {
                    organisation_id: orgId,
                    domain_id: domainId
                }

                //api call
                await deleteDomain(body);

                //after successful deletion, the deleted domain is deleted from the domainsList locally 
                //instead of fething the complete list again
                this.domainsList = this.domainsList.filter(domain => domain._id!=domainId);
                loader(this,false);

            }catch(error){
                loader(this,false);  
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }

        }


    }
}